import { CalendarOptionsRefined, Theme, createPlugin as fcCreatePlugin } from '@fullcalendar/common';

export class PetcoCalendarTheme extends Theme {
    constructor(options: CalendarOptionsRefined) {
        super(options);

        this.classes = {
            root: 'fcThemePetco',
            table: 'themeTable',
            tableCellShaded: 'themeTable-active',
            buttonGroup: 'btn-group',
            button: 'btn btn-primary',
            buttonActive: 'active',
            popover: 'popover',
            popoverHeader: 'popover-header',
            popoverContent: 'popover-body',
        };

        this.baseIconClass = 'fa';

        this.iconClasses = {
            close: 'fa-times',
            prev: 'fa-chevron-left',
            next: 'fa-chevron-right',
            prevYear: 'fa-angle-double-left',
            nextYear: 'fa-angle-double-right',
        };

        this.rtlIconClasses = {
            prev: 'fa-chevron-right',
            next: 'fa-chevron-left',
            prevYear: 'fa-angle-double-right',
            nextYear: 'fa-angle-double-left',
        };

        this.iconOverrideOption = 'bootstrapFontAwesome';
        this.iconOverrideCustomButtonOption = 'bootstrapFontAwesome';
        this.iconOverridePrefix = 'fa-';
    }

    static createPlugin() {
        return fcCreatePlugin({
            themeClasses: {
                petco: PetcoCalendarTheme
            }
        })
    }
}
